import { RegisterPayload, CompetitionPayload } from 'models/endpoints-payload'
import { RegisterResponse } from 'models/endpoints-respone'

import { pushDataLayer } from 'utils/data-layer-push'
import { getCurrentLanguage } from 'utils/current-language'

import { registerUser } from 'services/register-user'
import competitionSubscribe from 'services/competition-subscribe'

import {
  checkIfPayloadComplete,
  createConfirmEmailUrl,
  handleFailedRegistration,
  bindPasswordControls,
  bindSubmitButton,
  resetAllErrorMSG,
  getFormData,
} from 'src/landings/__assets__/scripts/components/form-handling'

const EVENT = 'PROMOKARTA16URO'

type FormContainer = Document | HTMLElement

declare const USER_BASE_URL_WT: string

const handleFormSubmit = async (
  $formContainer: FormContainer = document,
  isWithCompetition: boolean = false,
): Promise<void> => {
  resetAllErrorMSG($formContainer)
  const payload = getFormData($formContainer)

  if (!checkIfPayloadComplete(payload)) {
    console.warn('Incomplete or invalid form data')
    return
  }

  try {
    const response = await registerUser(payload)
    await handleSuccessfulRegistration(payload, response, isWithCompetition)
  } catch (error: unknown) {
    handleFailedRegistration(error, $formContainer)
  }
}

const handleSuccessfulRegistration = async (
  payload: RegisterPayload,
  response: RegisterResponse,
  isWithCompetition: boolean,
): Promise<void> => {
  const language = payload.language || getCurrentLanguage()
  const registrationRef = response.ref || ''

  pushDataLayer('form_submitted', { form_name: 'Rejstracja z landingu', form_url: window.location.href })

  if (isWithCompetition && payload.email) {
    try {
      const competitionPayload: CompetitionPayload = {
        email: payload.email,
        event: EVENT,
        answer: '',
        date: new Date().toISOString(),
        terms_and_conditions_accepted: payload.terms_and_conditions_accepted,
      }

      await competitionSubscribe(competitionPayload)
    } catch (error: unknown) {
      console.error('Failed to subscribe to competition:', error)
    }
  }

  window.location.href = createConfirmEmailUrl(USER_BASE_URL_WT, { language, registrationRef })
}

export const initForm = (isWithCompetition: boolean = false): void => {
  bindSubmitButton(document, () => handleFormSubmit(document, isWithCompetition))
  bindPasswordControls(document)
}
